document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("gb-compare-manual-form");
  if (!form) return;

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const ids = [
      document.getElementById("gb-product-id-1").value.trim(),
      document.getElementById("gb-product-id-2").value.trim(),
      document.getElementById("gb-product-id-3").value.trim(),
      document.getElementById("gb-product-id-4").value.trim(),
    ].filter(Boolean);

    if (ids.length === 0) {
      alert("Please enter at least one product ID.");
      return;
    }

    try {
      const items = ids.map(id => ({ productId: id }));
      const data = await fetchSpecsFromAPI(items);

      if (Object.keys(data).length > 0) {
        renderComparisonTable(data);
      } else {
        alert("No specs found for the entered IDs.");
      }
    } catch (err) {
      console.error("Error fetching product specs:", err);
      alert("Failed to fetch product specs.");
    }
  });
});

// --- Fetch from API --- //
async function fetchSpecsFromAPI(items) {
  try {
    const res = await fetch("https://gb-variant-comparison.vercel.app/api/get-product-specs-metafields", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items })
    });

    if (!res.ok) {
      console.error("API error:", res.status);
      return {};
    }

    const apiData = await res.json();
    const formatted = {};

    (apiData.results || []).forEach(item => {
      if (item?.error) return;

      const parsedSpecs = item.comparison_specs ? JSON.parse(item.comparison_specs) : {};
      const key = String(item.originalId || item.productId);

      formatted[key] = {
        gid: item.productId,
        title: item.productTitle || "(Untitled Product)",
        handle: item.handle || null,
        productUrl: item.handle ? `https://gibbyselectronicsupermarket.ca/products/${item.handle}` : null,
        image: item.image || null,
        specs: parsedSpecs,
        variants: item.variants || [],
        // keep fallback metafields
        features: item.features || null,
        type: item.type || null,
        display_technology: item.display_technology || null,
        channels: item.channels || null,
        car_speaker_design: item.car_speaker_design || null,
        fuse_rating: item.fuse_rating || null,
        watts_per_channel: item.watts_per_channel || null,
      };
    });

    return formatted;

  } catch (e) {
    console.error("Exception during fetchSpecsFromAPI:", e);
    return {};
  }
}

// --- Formatting helper --- //
function formatLabel(str) {
  if (!str) return "";
  return str.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}

// --- Render comparison table --- //
function renderComparisonTable(data) {
  const entries = Object.entries(data);

  const allSections = [];
  const seenSections = new Set();
  entries.forEach(([, product]) => {
    Object.keys(product.specs || {}).forEach(sectionKey => {
      if (!seenSections.has(sectionKey)) {
        allSections.push(sectionKey);
        seenSections.add(sectionKey);
      }
    });
  });

  let html = "<colgroup><col class='gb-feature-col'>";
  entries.forEach(() => (html += "<col class='gb-product-col'>"));
  html += "</colgroup><thead>";

  // Images
  html += "<tr class='gb-compare-table-img-row'><th></th>";
  entries.forEach(([, p]) => {
    html += `<th>${p.image ? `<img src="${p.image}" style="max-width: 200px" class="gb-comparison-image">` : ""}</th>`;
  });
  html += "</tr>";

  // Titles
  html += "<tr><th>Products</th>";
  entries.forEach(([, p]) => {
    html += `<th>${p.title}</th>`;
  });
  html += "</tr>";

  // Variants
  html += `<tr class="gb-normal-row"><td>Variants</td>`;
  entries.forEach(([, p]) => {
    let cell = "-";
    if ((p.variants || []).length > 1) {
      cell = p.variants.map(v => v.title).join(", ");
    }
    html += `<td>${cell}</td>`;
  });
  html += `</tr>`;

  // Visit Product buttons
  html += "<tr class='gb-actions-row'><th></th>";
  entries.forEach(([, p]) => {
    const url = p.productUrl || "https://gibbyselectronicsupermarket.ca/";
    html += `
      <th>
        <a href="${url}" target="_blank" type="button"
           class="btn btn--primary w-full gb-compare-page-btn">
          Visit Product
        </a>
      </th>
    `;
  });
  html += "</tr>";

  html += "</thead><tbody>";

  // JSON-based specs (normal)
  allSections.forEach(sectionKey => {
    let isNested = false;
    entries.forEach(([, p]) => {
      const val = p.specs?.[sectionKey];
      if (typeof val === "object" && val !== null) isNested = true;
    });

    if (isNested) {
      html += `<tr class="gb-subheading-row"><td>${formatLabel(sectionKey)}</td>`;
      entries.forEach(() => { html += `<td></td>`; });
      html += `</tr>`;

      const subKeys = [];
      const seenSubKeys = new Set();
      entries.forEach(([, p]) => {
        const val = p.specs?.[sectionKey];
        if (typeof val === "object" && val) {
          Object.keys(val).forEach(subKey => {
            if (!seenSubKeys.has(subKey)) {
              subKeys.push(subKey);
              seenSubKeys.add(subKey);
            }
          });
        }
      });

      subKeys.forEach(subKey => {
        const norm = subKey.toLowerCase();

        if (norm === "dimensions") {
          html += `<tr class="gb-child-row"><td>${formatLabel(subKey)}</td>`;
          entries.forEach(([, p]) => {
            const dims = p.specs?.[sectionKey]?.[subKey] || {};
            const normalize = v => (v === "" || v == null ? null : v);

            const w  = normalize(dims["Width Number"]  ?? dims["Width"]);
            const wu = normalize(dims["Width Unit"]);
            const h  = normalize(dims["Height Number"] ?? dims["Height"]);
            const hu = normalize(dims["Height Unit"]);
            const d  = normalize(dims["Depth Number"]  ?? dims["Depth"]);
            const du = normalize(dims["Depth Unit"]);

            const parts = [];
            if (w || wu) parts.push(`${w ?? "-"} ${wu ?? ""} (W)`.trim());
            if (h || hu) parts.push(`${h ?? "-"} ${hu ?? ""} (H)`.trim());
            if (d || du) parts.push(`${d ?? "-"} ${du ?? ""} (D)`.trim());

            const txt = parts.length > 0 ? parts.join(" x ") : "-";
            html += `<td>${txt}</td>`;
          });
          html += `</tr>`;
        } else if (norm === "weight") {
          html += `<tr class="gb-child-row"><td>${formatLabel(subKey)}</td>`;
          entries.forEach(([, p]) => {
            const wt = p.specs?.[sectionKey]?.[subKey];
            let txt = "-";

            if (wt && typeof wt === "object") {
              const normalize = v => (v === "" || v == null ? null : v);
              const num  = normalize(wt["Weight Number"] ?? wt["Number"] ?? wt["value"]);
              const unit = normalize(wt["Weight Unit"]   ?? wt["Unit"]);
              if (num || unit) txt = `${num ?? "-"} ${unit ?? ""}`.trim();
            } else if (wt != null && wt !== "") {
              txt = `${wt}`;
            }
            html += `<td>${txt}</td>`;
          });
          html += `</tr>`;
        } else {
          html += `<tr class="gb-child-row"><td>${formatLabel(subKey)}</td>`;
          entries.forEach(([, p]) => {
            const v = p.specs?.[sectionKey]?.[subKey];
            let out = "-";
            if (v == null) out = "-";
            else if (typeof v === "object") {
              const vals = Object.values(v).filter(x => x !== "" && x != null);
              out = vals.length ? vals.join(", ") : "-";
            } else out = String(v);
            html += `<td>${out}</td>`;
          });
          html += `</tr>`;
        }
      });

    } else {
      html += `<tr class="gb-normal-row"><td>${formatLabel(sectionKey)}</td>`;
      entries.forEach(([, p]) => {
        const value = p.specs?.[sectionKey] ?? "-";
        html += `<td>${value}</td>`;
      });
      html += `</tr>`;
    }
  });

  // --- Fallback "More Information" category ---
  const fallbackFields = [
    "features",
    "type",
    "display_technology",
    "channels",
    "car_speaker_design",
    "fuse_rating",
    "watts_per_channel",
  ];

  // Check if at least one product has any fallback data
  const hasFallbackData = entries.some(([, p]) => {
    const hasNoSpecs = !p.comparison_specs && (!p.specs || Object.keys(p.specs).length === 0);
    if (!hasNoSpecs) return false;
    return fallbackFields.some(field => p[field] && String(p[field]).trim() !== "");
  });

  if (hasFallbackData) {
    html += `<tr class="gb-subheading-row"><td>More Information</td>`;
    entries.forEach(() => { html += `<td></td>`; });
    html += `</tr>`;

    fallbackFields.forEach(field => {
      // Skip if all products have this field empty
      const allEmpty = entries.every(([, p]) => {
        const val = p[field];
        return !val || String(val).trim() === "";
      });
      if (allEmpty) return;

      html += `<tr class="gb-child-row"><td>${formatLabel(field)}</td>`;
      entries.forEach(([, p]) => {
        // Only show fallback if product has no specs
        if (p.comparison_specs || (p.specs && Object.keys(p.specs).length > 0)) {
          html += `<td>-</td>`;
          return;
        }

        const val = p[field];
        if (!val || String(val).trim() === "") {
          html += `<td>-</td>`;
          return;
        }

        let cellContent = val;

        // Detect list-type content
        try {
          const parsed = JSON.parse(val);
          if (Array.isArray(parsed)) {
            cellContent = `<ul>${parsed.map(x => `<li>${x}</li>`).join("")}</ul>`;
          }
        } catch {
          if (val.includes(",") && val.split(",").length > 1) {
            const listItems = val.split(",").map(x => x.trim()).filter(Boolean);
            cellContent = `<ul>${listItems.map(x => `<li>${x}</li>`).join("")}</ul>`;
          }
        }

        html += `<td>${cellContent}</td>`;
      });
      html += `</tr>`;
    });
  }

  const table = document.getElementById("gb-comparison-table");
  if (!table) return;
  table.innerHTML = html;
}
